<template>
  <div
    class="h-full min-h-screen md:min-h-0 flex flex-col onboarding"
    :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
  >
    <div class="z-20 absolute left-9 top-9 cursor-pointer" @click="onSkip">
      <Icon id="close" :color="themeIsDark ? '#fff' : '#000'" />
    </div>
    <NavMenu class="z-20" />
    <Carousel :perPage="1" v-model="slideIndex" :paginationEnabled="false">
      <Slide v-for="(slide, index) in slides" :key="index">
        <div
          class="flex flex-col flex-1 md:overflow-y-scroll relative px-10 pt-10"
        >
          <div class="relative z-10 mb-8">
            <p class="text-xl font-bold text-center mb-6 max-w-244 md:max-w-xl mx-auto" :style="$themeStyle">
              {{ slide.title }}
            </p>
            <p
              class="text-sm text-center"
              v-html="slide.text"
              :style="$themeStyle"
            ></p>
          </div>
          <div
            class="
              h-full
              relative
              top-0
              left-0
              w-full
              flex
              justify-center
              items-center
              md:items-start
            "
          >
            <AnimationCard :id="slide.animationId" />
          </div>
        </div>
      </Slide>
    </Carousel>
    <div>
      <div
        :class="themeIsDark ? 'text-white' : 'text-black'"
        class="p-10 fixed left-0 md:absolute bottom-0 w-full"
      >
        <div class="mb-8">
          <Button @click.native="onNext" :title="$t('onboardingButtonNext')" />
        </div>
        <span @click="onSkip" class="cursor-pointer text-base text-center block" data-testid="onboarding-skip">{{
          $t("onboardingButtonSkip")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { Carousel, Slide } from 'vue-carousel'
import { TranslationHandler } from '../../mixins/translation-handler'
import { RouteGuardHandler } from '../../mixins/route-guard-handler'
import { ThemeHandler } from '../../mixins/theme-handler'

@Component({
  components: {
    Carousel,
    Slide,
  }
})
export default class Onboarding extends Mixins(TranslationHandler, RouteGuardHandler, ThemeHandler) {
  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
  @Getter themeLogoImageUrl!: string
  @Getter storageKeyPage!: string

  slideIndex = 0

  get slides (): { animationId: string, title: string, text: string }[] {
    return [
      {
        animationId: 'playlist',
        title: this.$t('onboardingTitle1'),
        text: this.$t('onboardingText1'),
      },
      {
        animationId: 'playlistWithNote',
        title: this.$t('onboardingTitle2'),
        text: this.$t('onboardingText2'),
      },
      {
        animationId: 'speaker',
        title: this.$t('onboardingTitle3'),
        text: this.$t('onboardingText3'),
      },
    ]
  }

  onNext () {
    if (this.slideIndex === this.slides.length - 1) {
      this.$router.push('/login')
      return
    }
    this.slideIndex += 1
  }

  onSkip () {
    const storedPage = localStorage.getItem(this.storageKeyPage)

    if (storedPage) {
      this.$router.push(storedPage)
    } else {
      this.$router.push('/login')
    }
  }
}
</script>
